// extracted by mini-css-extract-plugin
export default {"container":"sZ-z","list":"tZ-z"};